/*
 * Copyright (c) 2022-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class User {
  firstName: string;
  lastName: string;
  email: string;
  gmin: string;
  zid: string;
  roles: string[];

  constructor(firstName?: string, lastName?: string, gmin?: string, zid?: string, email?: string,
              roles?: string[]) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.gmin = gmin;
    this.zid = zid;
    this.roles = roles;
  }

  public hasRoles(): boolean {
    return (this.roles != null && this.roles.length > 0);
  }

  // method for checking roles,
  // strict checking true requires permissions have all required permissions i.e ['abc', 'cdc'] == ['cdc', 'abc'] returns true
  // strict checking off only requires one element to be in user permissions i.e ['abc' , 'cdc'] == ['cdc'] returns true
  public checkRoles(allowedRolesList: string[], strictChecking: boolean = false): boolean {
    let result = false;
    // allow to see, this is for viewing of menu items that must return boolean
    if (allowedRolesList.includes('*')) {
      return true;
    }
    if (strictChecking && this.roles != null) {
      if (this.roles.filter(item => allowedRolesList.indexOf(item) < 0).length < 1
          &&
          allowedRolesList.filter(item => this.roles.indexOf(item) < 0).length < 1) {
        // two permssion list do contain all elements, order is ignored
        result = true;
      }
    } else {
      if (this.roles != null) {
        result = this.roles.some(item => allowedRolesList.includes(item));
      }
    }

    return result;
  }

  public firstLast() {
    // return first last or whichever name we do have
    if (this.firstName && this.lastName) {
        return this.firstName + ' ' + this.lastName;
    }
    if (this.firstName) {
        return this.firstName;
    }
    if (this.lastName) {
        return this.lastName;
    }
    return '';
  }
}
export class SearchUser {
  gmin: string;
  gmid: string;
  fullName: string = '';
  email: string;
  title: string;
  profilePicUrl: string;

  constructor() {
  }
  setUser(user: User) {
    this.gmin = user.gmin;
    this.gmid = user.zid;
    // call firstLast if it exists
    if (user.firstLast) {
      this.fullName = user.firstLast();
    } else if (user['fullName']) {
      this.fullName = user['fullName'];
    } else {
      this.fullName = user.firstName + ' ' + user.lastName;
    }
    this.email = user.email;
    this.profilePicUrl = 'https://peoplefinder.gm.com/Photos/' + user.gmin.substr(0, 3)
        + '/' + user.gmin.substr(3, 3) + '/' + user.gmin + '_SThumb.jpg';
  }
}
